module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-het"
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0010_device_embedded_information_detail_bulk_edit")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "機器・組込情報(一括編集）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "25%",
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        状態:\n        "), _c('select', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showApplyButton == true),
      expression: "showApplyButton == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.onLocalSaveBulkDevEmbedded
    }
  }, [_vm._v("下書保存")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])])], 1), _vm._v(" "), _c('device-embedded-information-confirmation-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmBulkDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onBulkDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "bulkDeviceEmbeddedApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "showConfimationModalSetdevice"
    },
    on: {
      "done": _vm.confirmedSetdevice
    }
  }), _vm._v(" "), _c('device-modal', {
    attrs: {
      "tag": "showdeviceModal"
    },
    on: {
      "selected": _vm.ondeviceModalSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4548c7c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0010_device_embedded_information_detail_bulk_edit.vue
// module id = 975
// module chunks = 0